import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import PostForm from './components/PostForm';

import { parseFormErrors } from '../shared/utils/form_errors';
import { CreatePostMutation } from './queries';

class NewPost extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit({ hasStringPrice, ...data }) {
    const { client, push } = this.props;
    
    data.tags = data.tags.items.map(item => {
      return item
    })

    return client.mutate({ mutation: CreatePostMutation, variables: { record: data } })
      .then(() => push('/posts'))
      .catch(parseFormErrors);
  }

  render() {
    const modelTags = this.props.modelTags;

    return (
      <div id="new-post">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/posts">Posts</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Post</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <span>Meow</span>
          <PostForm onSubmit={this.handleSubmit} modelTags={modelTags}/>
        </div>
      </div>
    );
  }
}

export default compose(
  connect(null, { push }),
  withApollo,
)(NewPost);
